export default "Review on the way ...\n\n<!-- Diana, Rasmus, Frank, Pede, Anker, Heidi -->\n\n\n<!-- gavekort, champagne, snak, slidt, lys-puzzle ustabilt -->";